import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage451Avaleht from "./pages/Webpage451Avaleht";
import Webpage453notfound from "./pages/Webpage453notfound";
import Webpage465pileti_bronn from "./pages/Webpage465pileti_bronn";

var baseURL = 'https://d2.itprojektid.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxMiIsImp0aSI6IjE2ZWQ1MTZlODYwYjA3ZmZjYTMxOGI1Zjc4NjcxMGZlMzIxMDVhZjZkMzY0MzBjNzAyNWJlNmI1NzE0YmViYmNmZjg3ZjE3MDBmNDA2YTkxIiwiaWF0IjoxNzczMjU3NjY1LjcwMjM4NCwibmJmIjoxNzczMjU3NjY1LjcwMjM4OCwiZXhwIjoxNzczMzQ0MDY1LjY5ODYwOCwic3ViIjoiNDAiLCJzY29wZXMiOltdfQ.mG73QVS5AhekD6La8lgLpYyElMfSW4N5beJkmWqablqbAuLUwas5khu_oxXrwrjve9KCAF2W1qaPFUHxZnXzQ5C1UmUheegl4KKYK1Ac5plh53rNC2zt3Jh6AhPH51BXyp3ZCyKq66Co7-eojlaQHmRxsf_ZWg9Kwz-8YdZw1irVydppLj6KMHdPHPJKmwuEu8OtyaUu49J281BPrvXrRPYKLB1XM3fyQU0Rcv8nd8_Lh_LlW_PDbK0b9i1CV73RwVXwZMV9iFGyTnOKJK1BFGyyHGR0RIFTzzohektN-vvNaTilZ7S9gt01YauZ3i9p8aPNfBqwYwXGQ5W-fSItZOlfw-DoS1aRRs1GNNUdp1rRX2s951lVdBPXhmXLchFvc3NbioCt6GMP2FcacTEI8bcCfgY8-xkXCur6GgJ0hOjW2WCVKt21_lnD6YIKqpiIiMpy1gmBKBuy1XUYcQckBTsFN6Eh4jS8icqifxlesrbhcTmbFf8q5clOFKek9uA4cvnu2RdqICtYq3NZdWyJ6ZLf3VNFI7TvFqP3wbJftlwgzRiM1KANqGM9wrg9iPR25TQkdjODI_4RAK0ABkKEqXmnAmLNLN4sMG_b1rhidLhLS61LA021_zwSRZqZxXDcLLJvYb4X-H6gNFWnDEoa1cr45XV6ZfxZ0UL1agldtz4',
    'Access-api-key': "eyJpdiI6IitlZk1xTkY2VXJPeENTY1pXYmZHSHc9PSIsInZhbHVlIjoiTnZROTdEem1RMlNlbmpUU0U2SVlPZz09IiwibWFjIjoiMGIwMDE4MjljYmIwYmFkMzQ5OTJkODhhMTY3OWZjODFlYjU0NjhmYTZiMzBjN2VkYzBiY2JhM2U5ODI1ZjYyNSIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6IldVUzk4QkcvVEVYT3djL09mUUlNQ3c9PSIsInZhbHVlIjoiank5bWl4TDR6RmVMcHFRZ1NPVklLdz09IiwibWFjIjoiMzNmZDI5MGZjYmM5NTI2OTdjYjc0YTA5NGRlYjIzOWVhMTRhZTBiNDY2MGRhYjY2ZDZhNDQyOWY4YWQwOGY1NyIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: ""
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/" element={<Webpage451Avaleht />} exact />;
                                                                    <Route path="/et/*" element={<Webpage453notfound />} exact />;
                                                <Route path="*" element={<Webpage453notfound />} exact />;
                                                                    <Route path="/et/pileti-bronn" element={<Webpage465pileti_bronn />} exact />;
                                                                
                                                            </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}